import { apiFetch } from './apiFetch'

export const fetchNews = async (token, searchTerm = 'retail') => {
  const results = await apiFetch({
    token,
    method: 'POST',
    path: '/proxy',
    payload: {
      url: `https://api.nytimes.com/svc/search/v2/articlesearch.json?q=${searchTerm}&api-key=${process.env.NYTIMES_KEY}`
    }
  })
  return results.response.docs
}

export const altNews = async (searchTerm = 'retail') => {
  const results = await fetch(
    `https://newsapi.org/v2/everything?q=${encodeURIComponent(searchTerm)}&sortBy=publishedAt`,
    {
      headers: {
        Authorization: 'eabdec6a07804b379fded6001c73210d'
      }
    }
  )
  return results.json()
}

// GET https://gnews.io/api/v4/search?q=example=token=API-Key

export const gNews = async (searchTerm = 'retail') => {
  const results = await fetch(
    `https://gnews.io/api/v4/search?lang=en&country=us&q=${searchTerm}&token=${process.env.GNEWS_API_KEY}`,
    {
      headers: {
        Authorization: 'f46b573bd0c1abfd89e70e694a4fbef9'
      }
    }
  )
  return results.json()
}

// newsdata.io via our API (key stays server-side). `terms` is a comma-separated string;
// returns [{ title, url, description, urlToImage, source, publishedAt }]
export const searchNews = async (terms = '') => {
  const res = await apiFetch({ path: `/news?q=${encodeURIComponent(terms)}` })
  return res?.articles || []
}
